import { useContext } from "react";

import { BanksListContext, IRefreshBanksListByCountry } from "../contexts";

export function useBanks(): IRefreshBanksListByCountry {
  const banksContext = useContext(BanksListContext);

  if (!banksContext)
    throw new Error(
      "The banks context can only be used inside the Banks Provider"
    );

  return banksContext;
}
